export default __webpack_public_path__ + "static/media/success-check.533a6148.png";